import { getDifficultyColor, getDifficultyLabel } from '@/lib/gamification';
import type { DifficultyLevel } from '@/types';

interface Props {
  difficulty: DifficultyLevel;
  showLabel?: boolean;
  size?: 'sm' | 'md';
}

export function DifficultyStars({ difficulty, showLabel = false, size = 'md' }: Props) {
  const color = getDifficultyColor(difficulty);
  const label = getDifficultyLabel(difficulty);
  const starSize = size === 'sm' ? 10 : 14;

  return (
    <span className="inline-flex items-center gap-1" aria-label={`Difficulty: ${label}`}>
      {Array.from({ length: 5 }, (_, i) => (
        <svg
          key={i}
          width={starSize}
          height={starSize}
          viewBox="0 0 14 14"
          fill={i < difficulty ? color : 'rgba(255,255,255,0.15)'}
          aria-hidden="true"
        >
          <path d="M7 1l1.545 3.13L12 4.635l-2.5 2.435.59 3.44L7 8.885l-3.09 1.625.59-3.44L2 4.635l3.455-.505z" />
        </svg>
      ))}
      {showLabel && (
        <span className="text-xs font-medium ml-1" style={{ color }}>
          {label}
        </span>
      )}
    </span>
  );
}
